// eslint-disable-next-line import/no-unresolved
require('./lib/initialize');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-dates/initialize.js
 ** module id = 1231
 ** module chunks = 0
 **/